// extracted by mini-css-extract-plugin
module.exports = {"siteNotificationCookieUsage":"CookieUsage_siteNotificationCookieUsage__2zTsY","link":"CookieUsage_link__3Uiez","btnSuccess":"CookieUsage_btnSuccess__1IIS-"};